import React from 'react';
import { Link } from 'react-router-dom';

const RiskDisclaimerCondensed = ({ hideReadMoreLink = false }) => {
  return (
    <div>
      <h5 style={{ margin: '10px 0' }}>Risk Disclosure and Important Notices</h5>
      <div style={{ fontSize: '0.9em', lineHeight: '1.6', opacity: 0.85 }}>
        <p>
          <strong>WARNING: Trading securities and options involves substantial risk of loss.</strong> You may 
          lose part or all of your invested capital. Only trade with risk capital—money you can afford to lose. 
          Past performance (actual or simulated) is NOT indicative of future results. No trading strategy can 
          guarantee profits or prevent losses.
        </p>
        <p>
          <strong>NOT INVESTMENT ADVICE:</strong> PrecisionTrader is a technology tool, NOT a registered investment 
          adviser or broker-dealer. We do NOT provide investment, financial, legal, or tax advice. All trading 
          decisions are made solely by you at your own discretion and risk. You should consult licensed financial 
          professionals before making investment decisions.
        </p>
        <p>
          <strong>PRECISIONAI:</strong> Optional AI-generated responses are for educational purposes only, 
          may be inaccurate or incomplete, and are NOT investment advice or trade recommendations. The AI does NOT 
          place orders or execute trades on your behalf. Verify any information before acting on it.
        </p>
        <p>
          <strong>Important Disclosure:</strong> PrecisionTrader is not affiliated or associated with, or a partner of, 
          or an agent, representative, delegate, associated person or introducing broker for, any TradeStation company. 
          The products and services offered by PrecisionTrader are not sponsored, endorsed, sold or promoted by any 
          TradeStation company, and TradeStation makes no representation regarding any products or services offered 
          by PrecisionTrader. Equities, equity options and commodity futures products and services are offered by 
          TradeStation Securities, Inc. (Member NYSE, FINRA, CME and SIPC).
        </p>
        <p>
          <strong>System Risks:</strong> Technology failures, outages, data delays, and software errors can occur. 
          System access and order execution may be delayed or fail due to market conditions, system issues, or 
          connectivity problems. Automated risk controls do NOT guarantee prevention of losses.
        </p>
        <p>
          <strong>Options Trading:</strong> Options involve additional risks beyond equity trading, including total 
          loss of premium and unlimited risk on certain strategies. Ensure you understand how options work before 
          trading them.
        </p>
        {!hideReadMoreLink && (
        <p style={{ marginTop: 16 }}>
          <Link 
            to="/legal#risk" 
            style={{ 
              color: 'var(--accent)', 
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: '1.05em'
            }}
          >
            Read Full Risk Disclosure & Regulatory Information →
          </Link>
        </p>
        )}
      </div>
    </div>
  );
};

export default RiskDisclaimerCondensed;

